module.exports = __webpack_public_path__ + "b5c8e90ccc709100c0b4390e1d0d4a24.png";